export interface TitleProps {
  title: string;
}

export function Title({ title }: TitleProps) {
  return <h1 className="pb-4 text-4xl">{title}</h1>;
}
